import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'boolean',
  pure: false
})
export class BooleanPipe implements PipeTransform {

  private outputValue: string = null;

  constructor(private translate: TranslateService) {
  }

  transform(value: any, mode: string = 'truefalse'): any {

    let lookup = '';
    if (typeof value === 'boolean') {
      lookup = 'cc.' + mode + (value ? '.true' : '.false');
    }
    else if (value) {
      lookup = 'cc.' + mode + '.' + value;
    }
    else {
      lookup = 'cc.' + mode + '.false';
    }
    this.translate.get(lookup).subscribe(trans => {
      this.outputValue = trans;
    });
    return this.outputValue;
  }
}
